module.exports = __webpack_public_path__ + "img/title-bg.e3c141d0.png";